(() => {
  const section = document.querySelector('[data-flowart-benefits]');
  if (!section) return;

  const initParallax = () => {
    // Check for Shopify Design Mode to avoid bugs in the editor
    if (window.Shopify && window.Shopify.designMode) return;
    if (!window.gsap) return;

    const gsap = window.gsap;

    if (section.dataset.flowartRevealBound === 'true') return;
    section.dataset.flowartRevealBound = 'true';

    const stickers = section.querySelectorAll('[data-flowart-sticker]');
    if (!stickers.length) return;

    if (typeof window.ScrollTrigger === 'undefined') return;
    gsap.registerPlugin(window.ScrollTrigger);

    // Obligamos a recalcular posiciones tras cargar imágenes (arregla distancias al actualizar la pagina a la mitad)
    window.addEventListener('load', () => window.ScrollTrigger.refresh(), { once: true });

    const mm = gsap.matchMedia();

    mm.add({
      isDesktop: "(min-width: 769px)",
      isMobile: "(max-width: 768px)"
    }, (context) => {
      let { isMobile } = context.conditions;

      // Timeline principal amarrada al scroll con configuraciones responsivas
      const cascadeTimeline = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: isMobile ? 'top 10%' : 'top 60%',
          end: isMobile ? 'bottom 90%' : 'bottom 85%',
          scrub: 1,
          invalidateOnRefresh: true
        }
      });

      const floatingTweens = [];

      stickers.forEach((sticker, index) => {
        const word = sticker.querySelector('[data-flowart-sticker-word]');
        const revealStart = index * 0.22;

        const currentRotate = parseFloat(sticker.style.getPropertyValue('--rotate')) || 0;

        // 1. Animación de revelado
        cascadeTimeline.fromTo(sticker, {
          autoAlpha: 0,
          scale: 0.5,
          y: isMobile ? 25 : 35,
          rotation: currentRotate + gsap.utils.random(-10, 10)
        }, {
          autoAlpha: 1,
          scale: 1,
          y: 0,
          rotation: currentRotate,
          ease: 'back.out(2)',
          duration: 0.5,
        }, revealStart);

        if (word) {
          // 2. Flotado perpetuo
          gsap.set(word, { y: 0, x: 0, rotate: 0 });

          const floatingTween = gsap.to(word, {
            y: gsap.utils.random(-6, -3),
            x: gsap.utils.random(-2, 2),
            rotate: gsap.utils.random(-2.4, 2.4),
            duration: 1.8 + index * 0.12,
            ease: 'sine.inOut',
            yoyo: true,
            repeat: -1,
            paused: true,
          });

          floatingTweens.push({
            word,
            tween: floatingTween,
            revealStart,
          });
        }
      });

      const timelineDuration = cascadeTimeline.duration() || 1;

      cascadeTimeline.eventCallback('onUpdate', () => {
        const currentProgress = cascadeTimeline.progress();
        floatingTweens.forEach((item) => {
          const revealPoint = (item.revealStart + 0.2) / timelineDuration;
          const shouldFloat = currentProgress >= revealPoint;

          if (shouldFloat) {
            if (item.tween.paused()) item.tween.play();
          } else {
            item.tween.pause(0);
          }
        });
      });

      return () => {
        floatingTweens.forEach(item => item.tween.kill());
        cascadeTimeline.kill();
      };
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initParallax, { once: true });
  } else {
    initParallax();
  }
})();